import { Component } from '@angular/core';

@Component({
  selector: 'app-contaier-tap-popup-checkbox',
  template: `
  <input type="checkbox" [checked]="isChecked" (change)="onCheckboxChange($event)" />
  `,
  styles: [`
    input[type="checkbox"] {
      cursor: pointer;
    }
    `],
})
// !access || 
export class ContainerTapPopupCheckboxComponent {

  // Define properties to hold the row data and checkbox state
  public params: any;
  public isChecked: boolean;
  //access; 

  agInit(params: any): void {
    this.params = params;
    //this.access = JSON.parse(localStorage.getItem('stock'));

    if (params.column === 'isstocked') {
      //params.data.stockCheck = this;
      this.isChecked = params.data?.stocked;
    }
  }

  onCheckboxChange(event: Event): void {
    this.isChecked = (event.target as HTMLInputElement).checked;
    this.params.data.stocked = this.isChecked;  
  }

  getValue(): any {
    return this.isChecked;
  }
}
